// CreateCreditLetterModalContent.js
import React, { forwardRef, useImperativeHandle, useState } from 'react';
import { Row, Col, Button, Form } from 'react-bootstrap';

const CreateCreditLetterModalContent = forwardRef(
  ({ onClose, onSubmit, initialData = {}, report, item }, ref) => {
    const [formData, setFormData] = useState({
      address: initialData.address || ''
    });
    const [errors, setErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false); // Track submission state

    // Validate the address field.
    const validateFields = () => {
      const newErrors = {};
      if (!formData.address) {
        newErrors.address = 'Address is required';
      }
      return newErrors;
    };

    // Handle address field change.
    const handleAddressChange = (e) => {
      setFormData({ ...formData, address: e.target.value });
      setErrors((prev) => ({ ...prev, address: '' }));
    };

    // Handle form submission
    const handleSubmit = async () => {
      const newErrors = validateFields();
      if (Object.keys(newErrors).length > 0) {
        setErrors(newErrors);
        return;
      }

      setIsSubmitting(true); // Disable button while submitting
      try {
        await onSubmit(formData, report, item);  // Pass report and item to onSubmit

      } catch (error) {
        console.error('Error during API call:', error);
      } finally {
        setIsSubmitting(false); // Re-enable the button
      }
    };

    // Expose reset method to parent component
    useImperativeHandle(ref, () => ({
      reset: () => {
        setFormData({ address: '' });
        setErrors({});
      }
    }));

    return (
      <>
        <Form>
          {/* Address Input Field */}
          <Form.Group controlId="formAddress">
            <Row className="align-items-center">
              <Col sm={4}>
                <Form.Label>
                  Address <span className="text-danger">*</span>
                </Form.Label>
              </Col>
              <Col sm={8}>
                <Form.Control
                  type="text"
                  value={formData.address}
                  onChange={handleAddressChange}
                  isInvalid={!!errors.address}
                />
                {errors.address && (
                  <Form.Control.Feedback type="invalid">
                    {errors.address}
                  </Form.Control.Feedback>
                )}
              </Col>
            </Row>
          </Form.Group>
        </Form>

        {/* Buttons */}
        <Row className="mt-3">
          <Col className="d-flex justify-content-start">
            <Button variant="secondary" onClick={onClose}>
              Cancel
            </Button>
          </Col>
          <Col className="d-flex justify-content-end">
            <Button
              variant="primary"
              onClick={handleSubmit}
              disabled={isSubmitting} // Disable submit button during API call
            >
              {isSubmitting ? 'Submitting...' : 'Submit'}
            </Button>
          </Col>
        </Row>
      </>
    );
  }
);

export default CreateCreditLetterModalContent;
